export class CopyBackgroundInfoPayload {
  sourceId: number;
  jurisdictionId?: number;
  uncontrolled: boolean;
}
